import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import sizesBanner from "./sizes-banner";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperNumber from "../../../../helpers/numbers";
import validateFormAddAdvertiseBanner from "../../../../validtions/forms/advertise/banner/add-banner";
import messages from "../../../../messages/advertise/banner";
import helperSpinner from "../../../../helpers/spinner";
import TitleBar from "../../../partials/content/TitleBar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function AddBanner() {
  const [message, setMessage] = useState({
    type_class: "",
    class_icon: "",
    text: "",
  });

  const generateMessageTagHtml = () => {
    if (message) {
      return (
        <div className={`${message.type_class}`}>
          <i className={`${message.class_icon} pl-2`}></i>
          <span>{message.text}</span>
        </div>
      );
    }
  };
  const history = useHistory();
  const params = useParams();
  const campaignID = params.id;

  const [banners, setBanners] = useState(() => {
    return sizesBanner.map((item, index) => {
      return {
        width: item.width,
        height: item.height,
        content: null,
        name: null,
        inputFileObject: null,
      };
    });
  });

  const uploadBanner = (width, height) => {
    const inputTagUploadBanner = document.querySelector(
      `#input-upload-banner-${width}-${height}`
    );
    inputTagUploadBanner.click();
  };

  const scrollForSeeMessage = () => {
    const element = document.getElementById("add-advertise-banner");
    element.scrollIntoView();
  };

  const checkTypeFile = (file) => {
    if (!file.type.includes("image/")) {
      return false;
    }
    return true;
  };

  const checkFileSize = (file) => {
    if (
      parseInt(file.size) >
      parseInt(process.env.REACT_APP_MAXIMUM_SIZE_IMAGE_FOR_ADVERTISE_BANNER)
    ) {
      return false;
    }
    return true;
  };

  const changeFileInput = async (e) => {
    let widthBannerTag = e.target.attributes["width"].value;
    let heightBannerTag = e.target.attributes["height"].value;
    let fileUploaded = e.target.files[0];
    if (!fileUploaded) {
      return;
    }

    if (!checkTypeFile(fileUploaded)) {
      scrollForSeeMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: messages.BANNER_FILE_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    if (!checkFileSize(fileUploaded)) {
      scrollForSeeMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: messages.BANNER_FILE_IS_HEAVY,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    const fileContents = await readUploadedFile(
      fileUploaded,
      widthBannerTag,
      heightBannerTag
    );

    if (fileContents == false) {
      return;
    }

    setBanners((banners) => {
      return banners.map((banner) => {
        if (
          banner.width == widthBannerTag &&
          banner.height == heightBannerTag
        ) {
          return {
            width: widthBannerTag,
            height: heightBannerTag,
            content: fileContents,
            name: fileUploaded.name,
            inputFileObject: fileUploaded,
          };
        }
        return banner;
      });
    });
  };

  const readUploadedFile = async (
    fileUploaded,
    widthBannerTag,
    heightBannerTag
  ) => {
    const temporaryFileReader = new FileReader();
    temporaryFileReader.readAsDataURL(fileUploaded);

    return new Promise((resolve, reject) => {
      temporaryFileReader.onload = async () => {
        const resultCheckSizeBanner = await checkSizeBanner(
          temporaryFileReader.result,
          widthBannerTag,
          heightBannerTag
        );

        if (resultCheckSizeBanner) {
          resolve(temporaryFileReader.result);
        } else {
          scrollForSeeMessage();
          setMessage({
            type_class: "alert alert-danger",
            text: messages.BANNER_SIZE_INVALID,
            class_icon: "fa fa-exclamation-triangle",
          });
          resolve(false);
        }
      };
    });
  };

  const checkSizeBanner = async (
    temporaryFileReader,
    widthBannerTag,
    heightBannerTag
  ) => {
    const image = new Image();
    image.src = temporaryFileReader;

    return new Promise((resolve, reject) => {
      image.onload = function () {
        let heightBannerSelected = this.height;
        let widthBannerSelected = this.width;
        if (
          !(
            heightBannerTag == heightBannerSelected &&
            widthBannerTag == widthBannerSelected
          )
        ) {
          resolve(false);
          return;
        }
        resolve(true);
      };
    });
  };

  const generateBoxUploadBanner = () => {
    return banners.map((banner, index) => {
      const width = banner.width;
      const height = banner.height;
      index++;

      const classAddDiv = banner.content ? "bg-hilite" : "bg-add-advertise-box";
      const imageURLInBox = banner.content
        ? "/assets/img/preview-image-banner-generator.svg"
        : "/assets/img/upload-banner-generator.svg";
      return (
        <div
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            uploadBanner(width, height);
          }}
          id={`select-banner-size-item-${index}`}
          className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 select-banner-size-item py-1 pb-2"
        >
          <div
            className={`d-flex flex-column text-center hover p-2  border border-1 border-dark ${classAddDiv} `}
          >
            <div>بنر تبلیغاتی را اضافه کنید </div>
            <div>
              <span>{helperNumber.toPersianNum(height)}</span>
              <span className="px-2">*</span>
              <span>{helperNumber.toPersianNum(width)}</span>
            </div>
            <div>
              <img style={{ width: "75px" }} src={imageURLInBox} />
            </div>

            <span>
              <input
                width={width}
                height={height}
                type="file"
                accept="image/jpg, image/jpeg, image/gif, image/webp"
                className="d-none"
                id={`input-upload-banner-${width}-${height}`}
                onChange={(event) => {
                  changeFileInput(event);
                }}
                onClick={(event) => {
                  event.target.value = null;
                }}
              />
            </span>
          </div>
        </div>
      );
    });
  };

  const removeBannerUploadedClick = (width, height) => {
    setBanners((prevState) => {
      return prevState.map((banner) => {
        if (banner.width == width && banner.height == height) {
          return {
            width: banner.width,
            height: banner.height,
            content: null,
            name: null,
            inputFileObject: null,
          };
        }
        return banner;
      });
    });
  };

  const generateTagBannerPreview = (width, height) => {
    return banners.map((banner, index) => {
      if (banner.width == width && banner.height == height) {
        if (!banner.content) {
          return;
        }

        return (
          <div className="border border-1 d-inline-block mt-2">
            <div className="text-center" dir="ltr">
              <span className="font-weight-bold">
                {helperNumber.toPersianNum(width)}
              </span>
              <span className="px-2">*</span>
              <span className="font-weight-bold">
                {helperNumber.toPersianNum(height)}
              </span>
            </div>
            <div className="hover img-preview-container position-relative">
              <div className="img-preview">
                <img className="img-fluid" src={banner.content} />
              </div>
              <div className="position-absolute d-flex align-items-center justify-content-center w-100 h-100">
                <span
                  className="btn btn-danger ml-1"
                  onClick={() => {
                    removeBannerUploadedClick(width, height);
                  }}
                >
                  <i className="fa fa-trash"></i>
                </span>
                <span
                  className="btn btn-success mr-1"
                  onClick={(e) => uploadBanner(width, height)}
                >
                  <i className="fa fa-edit"></i>
                </span>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const data = getDataForm();
    if (data == false) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddAdvertiseBanner =
      await sendRequestAddAdvertiseBanner(data);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddAdvertiseBanner) {
      return;
    }
    history.push("/advertise/banner/all");
  };

  const getDataForm = () => {
    let bannersFileImage = getBannerFileImage();
    if (bannersFileImage == false) {
      return false;
    }

    const address = document.getElementById("address").value;
    const dataInputs = {
      address: address,
    };
    const resultValidateFormAddAdvertiseBanner =
      validateFormAddAdvertiseBanner(dataInputs);
    if (resultValidateFormAddAdvertiseBanner != true) {
      scrollForSeeMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidateFormAddAdvertiseBanner,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let data = new FormData();
    data.append("address", address);
    data.append("campaign_id", campaignID);
    bannersFileImage.forEach((banner, index) => {
      data.append(banner.name, banner.file);
    });
    return data;
  };

  const getBannerFileImage = () => {
    const checkAtLeastOneBannerSelected = banners.some((banner) => {
      if (banner.content != null) {
        return true;
      }
      return false;
    });

    if (checkAtLeastOneBannerSelected == false) {
      scrollForSeeMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: messages.BANNER_NOT_EXIST,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const bannersForAddAdvertiseRequest = [];
    banners.forEach((banner) => {
      if (banner.content != null) {
        bannersForAddAdvertiseRequest.push({
          name: `banner_${banner.width}_${banner.height}`,
          file: banner.inputFileObject,
        });
      }
    });

    return bannersForAddAdvertiseRequest;
  };

  const sendRequestAddAdvertiseBanner = async (data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/advertise/banner",
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      scrollForSeeMessage();
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="all-advertise" />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن تبلیغ بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="add-advertise-banner">
              <div className="text-left pb-2">
                <Link to="/advertise/banner/all" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      بنرهای تبلیغاتی می تواند یکی از پسوند های
                      JPG,JPEG,GIF,WEBP باشد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      ۱۵ ثانیه حداکثر زمان برای بنر های gif هست.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      بنرهای تبلیغاتی JPG,JPEG,WEBP دارای زمان ثابت ۱۱ ثانیه
                      هستند.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      حداکثر حجم فایل ۱۵۰ کیلوبایت است.
                    </p>
                  </li>
                </ul>
              </div>

              {generateMessageTagHtml()}
              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label>آدرس صفحه‌ی فرود تبلیغ شما </label>
                  <input type="text" className="form-control" id="address" />
                </div>
                <div>
                  <label>اندازه جایگاه تبلیغات بنری (پیکسل) </label>
                  <div className="container-fluid select-banner-size-item-container py-3">
                    <div className="row">{generateBoxUploadBanner()}</div>
                  </div>
                </div>

                <div
                  className="container-fluid"
                  id="img-upload-banners-container"
                >
                  <div className="row">
                    <div
                      className="col-12 col-lg-3 img-preview-banner-item text-center"
                      id="img-preview-banner-item-120-600"
                    >
                      {generateTagBannerPreview(120, 600)}
                    </div>

                    <div
                      className="col-12 col-lg-3 img-preview-banner-item text-center"
                      id="img-preview-banner-item-180-600"
                    >
                      {generateTagBannerPreview(180, 600)}
                    </div>

                    <div
                      className="col-12 col-lg-6 img-preview-banner-item text-center"
                      id="img-preview-banner-item-300-600"
                    >
                      {generateTagBannerPreview(300, 600)}
                    </div>

                    <div
                      className="col-12 py-2 img-preview-banner-item text-center"
                      id="img-preview-banner-item-300-250"
                    >
                      {generateTagBannerPreview(300, 250)}
                    </div>

                    <div
                      className="col-12 py-2 img-preview-banner-item text-center"
                      id="img-preview-banner-item-720-300"
                    >
                      {generateTagBannerPreview(720, 300)}
                    </div>

                    <div
                      className="col-12 py-2 img-preview-banner-item text-center"
                      id="img-preview-banner-item-970-90"
                    >
                      {generateTagBannerPreview(970, 90)}
                    </div>

                    <div
                      className="col-12 py-2 img-preview-banner-item text-center"
                      id="img-preview-banner-item-970-250"
                    >
                      {generateTagBannerPreview(970, 250)}
                    </div>
                  </div>
                </div>

                <button type="submit" className="btn btn-success">
                  اضافه کردن
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddBanner;
